import { render, staticRenderFns } from "./businessDetailUser.vue?vue&type=template&id=009a7d16&scoped=true"
import script from "./businessDetailUser.vue?vue&type=script&lang=js"
export * from "./businessDetailUser.vue?vue&type=script&lang=js"
import style0 from "./businessDetailUser.vue?vue&type=style&index=0&id=009a7d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009a7d16",
  null
  
)

export default component.exports